// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Shops_breadcrumbs__u4c0X","title":"Shops_title__GNmAy","tabsContainer":"Shops_tabsContainer__W62Jb","load":"Shops_load__8roMN"};